const TOKEN_KEY = "superbar_access_token";
const IMPERSONATION_KEY = "superbar_impersonation";

export async function fetchWithAuth(url: string, options?: RequestInit): Promise<Response> {
  const token = localStorage.getItem(TOKEN_KEY);
  const impersonatedRole = localStorage.getItem(IMPERSONATION_KEY);
  
  const headers = new Headers(options?.headers);

  if (token) {
    headers.set('Authorization', `Bearer ${token}`);
  }

  if (impersonatedRole) {
    headers.set('x-superbar-impersonate-role', impersonatedRole);
  }

  if (!headers.has('Content-Type')) {
    headers.set('Content-Type', 'application/json');
  }

  return fetch(url, {
    ...options,
    headers,
  });
}
